import ErrorBoundary from 'components/ErrorBoundary'
import React, { lazy,Suspense } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import { importRetry } from 'utils/imports'

import './style.css'
import '../../components/lib/NakedButton/style.css'

const WidgetController = lazy( () => (
  importRetry(() => import('pages/WidgetController'))
))

const ChatPage = lazy( () => (
  importRetry(() => import('pages/Chat'))
))

const TakeOverPage = lazy( () => (
  importRetry(() => import('pages/TakeOver'))
))

const EmailCapturePage = lazy( () => (
  importRetry(() => import('pages/EmailCapture'))
))

const SliderPage = lazy( () => (
  importRetry(() => import('pages/Slider'))
))

const LandingPage = lazy(() => importRetry(() => import('pages/LandingPage')))

const AppLayout = () => {
  return (
    <ErrorBoundary>
      <Router basename="core">
        <>
          <Switch>
            <Route exact path="/">
              <Suspense fallback={<div />}>
                <WidgetController />
              </Suspense>
            </Route>

            <Route path="/chat">
              <Suspense fallback={<div />}>
                <ChatPage />
              </Suspense>
            </Route>

            <Route path="/takeover">
              <Suspense fallback={<div />}>
                <TakeOverPage />
              </Suspense>
            </Route>

            <Route path="/emailCapture">
              <Suspense fallback={<div />}>
                <EmailCapturePage />
              </Suspense>
            </Route>

            <Route exact path="/slider">
              <Suspense fallback={<div />}>
                <SliderPage />
              </Suspense>
            </Route>

            <Route exact path="/landingPage">
              <Suspense fallback={<div />}>
                <LandingPage />
              </Suspense>
            </Route>
          </Switch>
        </>
      </Router>
    </ErrorBoundary>
  )
}

export default AppLayout
